/**
 * @TODO: Load from FireStore
 */
const queryFirstRunTimeStamp = () => {

}

/**
 * @return {number}
 */
const getFirstRunTimeStamp = () => {
    try {
        const now = Date.now();
        const firstRunTS = parseInt(localStorage.getItem('firstRunTS') || `${now}`);
        const firstRunTSFS = parseInt(localStorage.getItem('firstRunTSFS') || `${now}`);

        return firstRunTS < firstRunTSFS ? firstRunTS : firstRunTSFS;
    } catch (error) {
        window.captureException(error);
        return 0;
    }
}

/*
 * @param {string|number} timestamp
 */
const setFirstRunTimeStamp = (timestamp) => {
    try {
        localStorage.setItem('firstRunTS', timestamp);
    } catch (error) {
        window.captureException(error);
    }
}

const getDaysUsed = () => {
    const firstRunTS = getFirstRunTimeStamp();
    const diff = parseInt(firstRunTS) - Date.now();
    const dateDiff = Math.ceil(diff / (1000 * 60 * 60 * 24));
    return dateDiff;
}

export { getDaysUsed, queryFirstRunTimeStamp, getFirstRunTimeStamp, setFirstRunTimeStamp }
